import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getDirection } from "../../../../../common-deprecated/themes/common";

export const Label = styled.label<SpaceProps>`
    margin-bottom: ${theme.space[3]}px;
    ${space};
`;

export type InputWrapperType = {
    hasIcon?: boolean;
};

export const InputWrapper = styled.div<InputWrapperType>`
  position: relative;
  input {
    width: 100%;
    padding: 15px 20px;
    padding-${getDirection("right")}: ${({ hasIcon }) => (hasIcon ? "60px" : "20px")};
    border: 1px solid ${theme.colors.grey2};
    &:focus {
      border: 1px solid ${theme.colors.grey4};
      outline: 0;
    }
  }
`;

export const InputWrapperIcon = styled.button`
    position: absolute;
    top: 16px;
    ${getDirection("right")}: ${theme.space[3]}px;
    color: ${theme.colors.primaryBlack};
    .icon::before {
        font-size: 1.7rem; /* hacky overwrite icon */
    }
`;

export const HelpText = styled.div<SpaceProps>`
    margin-top: 10px;
    font-size: 1.3rem;
    color: ${theme.colors.grey7};
`;

export const Error = styled.div<SpaceProps>`
    margin-top: 10px;
    font-size: 1.3rem;
    color: ${theme.colors.primaryRed};
`;

export const MandatoryField = styled.span<{ largeFontSize?: boolean }>`
    padding-${getDirection("left")}: 4px;
    font-family: ${theme.fonts.regular};
    font-size: ${({ largeFontSize }) => (largeFontSize ? 1.6 : 1)}rem;
    line-height: 2.4rem;
    color: ${theme.colors.primaryRed};
`;
